// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","pageLoader":"pageLoader_pageLoader__cWEuq"};